import { render, staticRenderFns } from "./InternalPromoSuggestions.vue?vue&type=template&id=656d2e6d"
import script from "./InternalPromoSuggestions.vue?vue&type=script&lang=js"
export * from "./InternalPromoSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports